module.exports = __webpack_public_path__ + "media/images/normas-ba_icon_144-98759dba3ff9bc20d002ec7b188c4dfe.png";